import React, { useMemo } from 'react';
import { useAppContext } from '../../../Services/AppContext';
export default function useScope() {
	const { globalTemplate } = useAppContext();

	const minimalPriceInputValue = useMemo(() => {
		switch (globalTemplate) {
			case 'peru':
				return 0.5;
			case 'ecuador':
				return 0.1;
			case 'mexico':
				return 2;
			case 'colombia':
				return 430;
			case 'slovakia':
				return 0.1;
			case 'czechia':
			default:
				return 1;
		}
	}, [globalTemplate]);

	return { minimalPriceInputValue };
}
